import { useEffect, useState } from 'react';
import { useMingo } from '../context/MingoContext';
import { getSupabase, isSupabaseConfigured } from '../lib/supabase';
import { fetchMyAppUserRow } from '../api/profileApi';
import {
  countUnreadNotifications,
  subscribeNotificationUnread,
} from '../api/notificationsApi';
import { unreadNotificationCount } from '../lib/notificationsCenter';

/** Header / shell: unread count (Supabase when logged-in app user exists, else local). */
export function useNotificationBadge() {
  const { isLoggedIn, isGuest } = useMingo();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isSupabaseConfigured || !getSupabase() || !isLoggedIn || isGuest) {
      setCount(unreadNotificationCount());
      function onLs() {
        setCount(unreadNotificationCount());
      }
      window.addEventListener('mingo-notifications', onLs);
      return () => window.removeEventListener('mingo-notifications', onLs);
    }

    let cancelled = false;
    let unsub = () => {};

    async function refreshCount() {
      const me = await fetchMyAppUserRow();
      if (cancelled || !me?.id) return;
      const n = await countUnreadNotifications(me.id);
      if (!cancelled) setCount(n);
    }

    function onForceRefresh() {
      void refreshCount();
    }

    (async () => {
      const me = await fetchMyAppUserRow();
      if (cancelled) return;
      if (!me?.id) {
        setCount(0);
        return;
      }
      unsub = subscribeNotificationUnread(me.id, (n) => {
        if (!cancelled) setCount(n);
      });
    })();

    window.addEventListener('mingo-notifications', onForceRefresh);

    return () => {
      cancelled = true;
      unsub();
      window.removeEventListener('mingo-notifications', onForceRefresh);
    };
  }, [isLoggedIn, isGuest]);

  return count;
}
